module.exports = __webpack_public_path__ + "img/adrs-logo.25f90163.jpg";